<template>
  <div id="doc"></div>
</template>
<script>
export default {
  props: {
    option: {
      type: Object,
      src: "",
      name: "",
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      doctype: ""
    };
  },
  mounted() {
    if (this.option.src) {
      this.setEditor(this.option);
    }
  },
  methods: {
    setEditor(option) {
      let script = document.createElement("script");
      script.type = "text/javascript";
      // let protocol = window.location.protocol;
      // script.src = `${protocol}//${fileDetail.serverUrl}/web-apps/apps/api/documents/api.js`
      script.src = `http://192.168.2.226/web-apps/apps/api/documents/api.js`;

      let app = document.getElementById("app");
      console.log("app===>", app);
      document.body.insertBefore(script, app);

      let file = option.src.split(".");
      let fileType = file[file.length - 1];

      let documentType1 = "Text";
      if (fileType === "doc" || fileType === "docx" || fileType === "pdf") {
        documentType1 = "Text";
      } else if (fileType === "xls" || fileType === "xlsx") {
        documentType1 = "spreadsheet";
      } else if (fileType === "pptx" || fileType === "ppt") {
        documentType1 = "presentation";
      }
      this.doctype = documentType1;

      console.log(fileType);
      setTimeout(() => {
        if (window["DocsAPI"]) {
          let data = {
            documentType: documentType1,
            height: "100%",
            width: "100%",
            type: "desktop",
            document: {
              title: option.name,
              url: option.src,
              fileType: fileType,
              key: String(new Date().valueOf()),
              info: {
                author: "Me",
                created: "04/08/2018"
              },
              permissions: {
                edit: false,
                download: false,
                print: false
              }
            },
            editorConfig: {
              mode: "view",
              lang: "zh-CN",
              callbackUrl: option.src,
              user: {
                id: "1",
                name: "aaa"
              },
              customization: {
                autosave: false,
                comments: false,
                forcesave: true,
                chat: false,
                help: false,
                customer: {}
              }
            },
            events: {
              onReady: this.onReady(),
              onDocumentStateChange: this.onDocumentStateChange(),
              onRequestEditRights: this.onRequestEditRights(),
              onError: this.onError(),
              onOutdatedVersion: this.onOutdatedVersion()
            }
          };
          window["DocsAPI"].docEditor = new window["DocsAPI"].DocEditor(
            "doc",
            data
          );
        }
      }, 1000);
    },

    onReady() {
      // this.innerAlert('Document editor ready')
      console.log("onReady");
    },
    onDocumentStateChange() {
      console.log("onDocumentStateChange");
    },
    onRequestEditRights() {
      console.log("onRequestEditRights");
      location.href = location.href.replace(RegExp("action=view&?", "i"), "");
    },
    onError(event) {
      console.log("onError===》", event);
    },
    onOutdatedVersion() {
      console.log("onOutdatedVersion");
    }
  }
  // watch: {
  //     option: {
  //         handler: function (n, o) {
  //             this.setEditor(n);
  //             this.doctype = handleDocType(n.fileType);
  //         },
  //         deep: true,
  //     }
  // }
};
</script>
